import DataStore from "../../../core/stores/dataStore.js";

export class WidgetController {
  constructor(id, legends) {
    this.id = id;
    this.legends = legends;
  }

  getLegends() {
    return this.legends;
  }

  /***
   *
   * @returns {Array}
   */
  processData(historicData) {
    let data = [];

    this.legends.forEach(legend => {
      const datasetsData = this.consolidateDatasetsData(legend, historicData);
      this.evaluateLegendExpression(legend, datasetsData);
      data.push(datasetsData)
    });

    return data;
  }

  consolidateDatasetsData(legend, historicData) {
    const datasetsData = {};

    for (let key in legend.mappings) {
      const datasetId = legend.mappings[key].datasetId;
      let datasetData;
      if (historicData) {
        datasetData = historicData[datasetId];
      } else {
        datasetData = DataStore.get(datasetId) || {};
      }
      datasetsData[datasetId] = datasetData;
    }

    if (historicData && legend.hasOwnProperty("serverSideFunction")) {
      legend.serverSideFunction.map(ssf => {
        const requestId = ssf.requestId;
        datasetsData[requestId] = historicData[requestId];
      });
    }

    return datasetsData;
  }

  evaluateLegendExpression(legend, datasetsData) {
    for (let key in legend.functions) {
      let fn = legend.functions[key];
      let value = null;
      try {
        value = fn(datasetsData);
      } catch (e) {
      }
      datasetsData[key] = value;
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/widgetController.js